import { render, staticRenderFns } from "./bottomCarousel.vue?vue&type=template&id=dadfbc0a&scoped=true&"
import script from "./bottomCarousel.vue?vue&type=script&lang=js&"
export * from "./bottomCarousel.vue?vue&type=script&lang=js&"
import style0 from "./bottomCarousel.vue?vue&type=style&index=0&id=dadfbc0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dadfbc0a",
  null
  
)

export default component.exports